import React, { useRef } from 'react';
import { Autocomplete, TextField, TextFieldProps } from '@mui/material';
import { Region } from '@ianesthesie-kit/services';
import { prettyPrintRegion } from '@/util';

export type RegionAutocompleteProps = {
  value?: Region;
  onChange: (v: Region) => void;
  label: string;
  error?: string;
  textFieldProps?: TextFieldProps;
  usOnly?: boolean;
};

export const RegionAutocomplete = ({
  value,
  onChange,
  label,
  error,
  usOnly,
  textFieldProps
}: RegionAutocompleteProps) => {
  const { current: options } = useRef(
    Object.values(Region).filter((r) => !usOnly || r !== Region.FRANCE)
  );

  return (
    <Autocomplete
      fullWidth
      selectOnFocus
      clearOnBlur
      disableClearable
      options={options}
      renderInput={(p) => (
        <TextField
          error={!!error}
          {...p}
          variant="outlined"
          label={label}
          {...textFieldProps}
        />
      )}
      getOptionLabel={prettyPrintRegion}
      value={value}
      onChange={(e, v) => onChange(v)}
    />
  );
};
